import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export default function useFetch(url, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reload = useCallback(async () => {
    setLoading(true);
    try { const r = await api.get(url); setData(r.data); setError(null); }
    catch (e) { setError(e); }
    finally { setLoading(false); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);
  useEffect(() => { reload(); /* eslint-disable-next-line */ }, deps);
  return { data, loading, error, reload, setData };
}
